import { PropertyDefinitionConfig } from '../types';

/** Pseudo-repository metadata for grid UI labels. */
export const GRID_REPOSITORY: PropertyDefinitionConfig = {
	id: 'idGridRepository',
	singular: 'Grid',
};
